"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchActivityPage = exports.buildActivityUrl = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _axios = _interopRequireDefault(require("axios"));

var ACTIVITY_URL_PATH = '/member/activity';

var buildActivityUrl = function buildActivityUrl(userId) {
  return (0, _absoluteUrlRuntime.resolveUrl)("".concat(ACTIVITY_URL_PATH, "?userId=").concat(userId));
};

exports.buildActivityUrl = buildActivityUrl;

var fetchActivityPage = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(userId, page) {
    var _data$totalCount, _data$payload;

    var _yield$axios$get, data;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.get(buildActivityUrl(userId), {
              params: {
                page: page
              }
            });

          case 2:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            return _context.abrupt("return", {
              totalCount: (_data$totalCount = data.totalCount) !== null && _data$totalCount !== void 0 ? _data$totalCount : 0,
              payload: (_data$payload = data.payload) !== null && _data$payload !== void 0 ? _data$payload : ''
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchActivityPage(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchActivityPage = fetchActivityPage;